
  export default {
    computed: {
      articles () {
        return this.$store.getters['blog/getList'];
      },
      provider () {
        return this.$store.getters['providers/get'];
      }
    }
  };
